<template>
	<div class="photos-view">
		<div class="btn" @click="attachAll">Vedhæft alle</div>
		<div class="container">
			<div @click="open(p.url)" v-for="(p, i) in _items" :key="i" class="thumb" :style="{
				backgroundImage: 'url(' + p.url + ')'
			}">
				<div class="attach" @click.stop="attach(p)">Vedhæft</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		asyncComputed: {
			_items: {
				lazy: true,
				async get() {
					var i;
					const urls = (await this.axios.post('/storage/urls/', this.value.map(item => item.id))).data;

					var r = [];

					for (var i = 0; i < this.value.length; ++i) {
						r.push({
							id: this.value[i].id,
							tags: this.value[i].tags,
							url: urls[i]
						});
					}

					

					return r;
				}
			}
		},
		methods: {
			open(url) {
				window.open(url);
			},
			attach(file) {
				

				this.$store.state.attachments.push({
					label: 'Billede ' + (this.$store.state.attachments.length + 1),
					id: file.id
				});
			},
			attachAll() {
				

				for (var i = 0; i < this._items.length; ++i) {
					this.attach(this._items[i]);
				}
			}
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss" scoped>
	.photos-view {
		& > .container {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
			grid-column-gap: 20px;
			grid-row-gap: 20px;

			& > .thumb {
				background-size: cover;
				height: 96px;
				cursor: pointer;
				position: relative;

				& > .attach {
					position: absolute;
					left: 0;
					bottom: 0;
					right: 0;
					line-height: 20px;
					text-align: center;
					background-color: black;
					color: white;
					font-size: 12px;
				}
			}
		}		
	}
</style>